//hooks
import { usePrefersReducedMotion } from '@/hooks/usePrefersReducedMotion';

//components
import {
  Section,
  Kicker,
  KickerDot,
  SectionTitle,
  SectionLede,
  Grad,
} from '@/containers-ai/SectionHeading';
import { Container } from '@/components/Grid';

//styles
import { RailsGrid, RailCard, DiagramSvg, FlowPath } from './Rails.styles';

export function Rails({ content }) {
  const prefersReducedMotion = usePrefersReducedMotion();
  const diagram = content.diagram;

  return (
    <Section id="rails">
      <Container>
        <RailsGrid>
          <div>
            <Kicker>
              <KickerDot />
              {content.kicker}
            </Kicker>
            <SectionTitle>
              {content.title}
              <Grad>{content.titleHighlight}</Grad>
            </SectionTitle>
            <SectionLede>{content.lede}</SectionLede>
          </div>
          <RailCard>
            <DiagramSvg
              viewBox="0 0 520 300"
              role="img"
              aria-label={diagram.ariaLabel}
            >
              <defs>
                <linearGradient id="g2" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0" stopColor="#00D7D7" />
                  <stop offset="1" stopColor="#14D64D" />
                </linearGradient>
              </defs>
              <g
                fontFamily="Manrope,system-ui,sans-serif"
                fontSize="10"
                fontWeight="600"
                letterSpacing="1.5"
                fill="#6C8583"
              >
                <text x="85" y="26" textAnchor="middle">
                  {diagram.systemsLabel}
                </text>
                <text x="455" y="106" textAnchor="middle" letterSpacing="1">
                  {diagram.freightWorldLabel}
                </text>
              </g>
              <g fill="none" stroke="#2A5B60" strokeWidth="1.3">
                <FlowPath d="M156 60 C 202 60 212 130 250 142" />
                <FlowPath d="M156 150 C 202 150 206 150 250 150" />
                <FlowPath d="M156 240 C 202 240 212 170 250 158" />
                <FlowPath d="M336 150 C 380 150 384 150 412 150" />
              </g>
              <g
                fontFamily="Manrope,system-ui,sans-serif"
                fontSize="10"
                fontWeight="500"
                fill="#6C8583"
              >
                <text x="196" y="50">
                  {diagram.apiLabel}
                </text>
                <text x="196" y="141">
                  {diagram.ediLabel}
                </text>
                <text x="196" y="254">
                  {diagram.mcpLabel}
                </text>
              </g>
              <g
                fontFamily="Manrope,system-ui,sans-serif"
                fontWeight="600"
                fontSize="12"
                fill="#EAF4F1"
              >
                <rect
                  x="20"
                  y="36"
                  width="130"
                  height="44"
                  rx="9"
                  fill="#0A222A"
                  stroke="#2A5B60"
                />
                <text x="85" y="62" textAnchor="middle">
                  {diagram.tmsLabel}
                </text>
                <rect
                  x="20"
                  y="128"
                  width="130"
                  height="44"
                  rx="9"
                  fill="#0A222A"
                  stroke="#2A5B60"
                />
                <text x="85" y="154" textAnchor="middle">
                  {diagram.erpWmsLabel}
                </text>
                <rect
                  x="20"
                  y="218"
                  width="130"
                  height="44"
                  rx="9"
                  fill="#0A222A"
                  stroke="#2A5B60"
                />
                <text x="85" y="244" textAnchor="middle">
                  {diagram.emailEdiLabel}
                </text>
                <rect
                  x="420"
                  y="122"
                  width="84"
                  height="56"
                  rx="10"
                  fill="#0A222A"
                  stroke="#2A5B60"
                />
                <text x="462" y="147" textAnchor="middle" fontSize="11">
                  {diagram.carriersLabel}
                </text>
                <text x="462" y="162" textAnchor="middle" fontSize="11">
                  {diagram.facilitiesLabel}
                </text>
              </g>
              <rect
                x="258"
                y="118"
                width="72"
                height="64"
                rx="12"
                fill="#0E2A31"
                stroke="url(#g2)"
                strokeWidth="2"
              />
              <text
                x="294"
                y="146"
                textAnchor="middle"
                fontFamily="Manrope,system-ui,sans-serif"
                fontSize="12"
                fontWeight="800"
                fill="#fff"
              >
                Loadsmart
              </text>
              <text
                x="294"
                y="163"
                textAnchor="middle"
                fontFamily="Manrope,system-ui,sans-serif"
                fontSize="12"
                fontWeight="800"
                fill="#14D64D"
              >
                AI
              </text>
              {!prefersReducedMotion && (
                <g>
                  <circle r="3.4" fill="#00D7D7">
                    <animateMotion
                      dur="4.2s"
                      repeatCount="indefinite"
                      keyPoints="0;1;0"
                      keyTimes="0;.5;1"
                      calcMode="linear"
                      path="M156 60 C 202 60 212 130 250 142"
                    />
                  </circle>
                  <circle r="3.4" fill="#14D64D">
                    <animateMotion
                      dur="4.6s"
                      repeatCount="indefinite"
                      begin="-1.6s"
                      keyPoints="0;1;0"
                      keyTimes="0;.5;1"
                      calcMode="linear"
                      path="M156 150 C 202 150 206 150 250 150"
                    />
                  </circle>
                  <circle r="3.4" fill="#14D64D">
                    <animateMotion
                      dur="3.8s"
                      repeatCount="indefinite"
                      begin="-.7s"
                      keyPoints="0;1;0"
                      keyTimes="0;.5;1"
                      calcMode="linear"
                      path="M336 150 C 380 150 384 150 412 150"
                    />
                  </circle>
                  <circle r="3.4" fill="#00D7D7">
                    <animateMotion
                      dur="5s"
                      repeatCount="indefinite"
                      begin="-2.4s"
                      keyPoints="0;1;0"
                      keyTimes="0;.5;1"
                      calcMode="linear"
                      path="M156 240 C 202 240 212 170 250 158"
                    />
                  </circle>
                </g>
              )}
            </DiagramSvg>
          </RailCard>
        </RailsGrid>
      </Container>
    </Section>
  );
}
